import React from 'react'
import SliderPressRelease from '../../component/slidercomponent/SliderDepartments'
import SliderOutTeam from '../../component/slidercomponent/SliderOutTeam'
import { Link } from "react-router-dom";


const PressRelease = () => {
  return (
    <>


      <section className="content-inner" style={{ backgroundImage: 'url(./assets/images/background/bg1.png)', backgroundRepeat: 'no-repeat', backgroundPosition: 'right bottom' }}>
        <div className="container">
          <div className="row content-wrapper style-1 align-items-center">
            <div className="col-xl-6 m-b30">
              <div className="content-media">
                <div className="dz-media">
                  <img src="./assets/images/about/img1.webp" alt />
                </div>
                <div className="item1 skrollable skrollable-before" data-bottom-top="transform: translateY(-50px)" data-top-bottom="transform: translateY(50px)" style={{ transform: 'translateY(-50px)' }}>
                  <div className="info-widget style-7">
                    <div className="widget-content bg-secondary">
                      100% विशेषज्ञ डॉक्टर
                    </div>
                    <div className="widget-media">
                      <img src="./assets/images/about/img2.webp" alt />
                      <div className="call-widget">
                        <a to="javascript:void(0);">
                          <img src="./assets/images/svg/camra.svg" alt />
                        </a>
                        <a to="javascript:void(0);">
                          <img src="./assets/images/svg/message.svg" alt />
                        </a>
                        <a to="javascript:void(0);" className="active">
                          <img src="./assets/images/svg/call.svg" alt />
                        </a>
                        <a to="javascript:void(0);">
                          <img src="./assets/images/svg/mike.svg" alt />
                        </a>
                        <a to="javascript:void(0);">
                          <img src="./assets/images/svg/video.svg" alt />
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                {/* <div className="item2 skrollable skrollable-before" data-bottom-top="transform: translateY(50px)" data-top-bottom="transform: translateY(-50px)" style={{ transform: 'translateY(50px)' }}>
                  <div className="info-widget style-6 bg-primary">
                    <div className="info-icon bg-secondary">
                      <img src="./assets/images/svg/clock.svg" alt />
                    </div>
                    <div className="widget-content">
                      <h4 className="title">Open Hours</h4>
                      <ul>
                        <li>Monday <strong>09:30 - 07:30</strong></li>
                        <li>Tuesday <strong>09:30 - 07:30</strong></li>
                        <li>Wednesday <strong>09:30 - 07:30</strong></li>
                        <li>Thursday <strong>09:30 - 07:30</strong></li>
                        <li>Friday <strong>09:30 - 07:30</strong></li>
                        <li>Saturday <strong>09:30 - 07:30</strong></li>
                      </ul>
                    </div>
                  </div>
                </div> */}
              </div>
            </div>
            <div className="col-xl-6 m-b30">
              <div className="section-head style-1 m-b30">
                <h2 className="title wow fadeInUp" data-wow-delay="0.2s" data-wow-duration="0.8s" style={{ visibility: 'visible', animationDuration: '0.8s', animationDelay: '0.2s', animationName: 'fadeInUp', marginTop: "-20px" }}>ओमकार मल्टीस्पेशलिटी हॉस्पिटल में आपका स्वागत है। </h2>
                <p className="wow fadeInUp" data-wow-delay="0.4s" data-wow-duration="0.8s" style={{ visibility: 'visible', animationDuration: '0.8s', animationDelay: '0.4s', animationName: 'fadeInUp' }}>ओमकार मल्टीस्पेशलिटी हॉस्पिटल एक भरोसेमंद स्वास्थ्य संस्थान है, जो करुणा, ईमानदारी और उत्कृष्टता के साथ उच्च गुणवत्ता वाली चिकित्सा सेवाएँ प्रदान करने के लिए प्रतिबद्ध है। हम उन्नत चिकित्सा तकनीक को अनुभवी डॉक्टरों, कुशल नर्सों और समर्पित सहायक कर्मचारियों की एक टीम के साथ जोड़ते हैं, ताकि व्यापक और रोगी-केंद्रित देखभाल सुनिश्चित की जा सके।</p>
                <p className="wow fadeInUp" data-wow-delay="0.4s" data-wow-duration="0.8s" style={{ visibility: 'visible', animationDuration: '0.8s', animationDelay: '0.4s', animationName: 'fadeInUp' }}>हम कई विशेषज्ञताओं में स्वास्थ्य सेवाओं की एक विस्तृत श्रृंखला प्रदान करते हैं, जिसमें सटीक निदान, प्रभावी उपचार और मरीज़ों को निरंतर सहयोग देने पर विशेष ध्यान दिया जाता है। ओंकार मल्टीस्पेशलिटी हॉस्पिटल सुरक्षा और स्वच्छता के कड़े मानकों का पालन करता है, जिससे मरीज़ों और उनके परिवारों के लिए एक स्वच्छ, सुरक्षित और आरामदायक वातावरण सुनिश्चित होता है।</p>
                {/* <p className="wow fadeInUp" data-wow-delay="0.4s" data-wow-duration="0.8s" style={{ visibility: 'visible', animationDuration: '0.8s', animationDelay: '0.4s', animationName: 'fadeInUp' }}>At the core of our philosophy is the belief that every patient deserves personalized attention, ethical treatment, and transparent communication. We strive to improve community health through preventive care, health education, and affordable medical services.</p> */}
              </div>
              <ul className=" text-secondary grid-2 fw-medium m-b30" >
                <li> ✅ बेहतरीन हेल्थकेयर</li>
                <li> ✅ सिर्फ़ क्वालिफ़ाइड डॉक्टर</li>
                <li> ✅ 100% एक्सपर्ट डॉक्टर</li>
                <li> ✅ मेडिकल रिसर्च प्रोफ़ेशनल</li>
                <li> ✅ दोस्ताना और भरोसेमंद सेवाएँ</li>
                <li> ✅ 24/7 इमरजेंसी सेवाएँ</li>



              </ul>
              <div className="d-flex flex-wrap align-items-center wow fadeInUp" data-wow-delay="0.8s" data-wow-duration="0.8s" style={{ animationDuration: '0.8s', animationDelay: '0.8s', animationName: 'none' }}>
                <Link to="/contact-us" className="btn btn-lg btn-icon btn-secondary btn-shadow m-r30 mb-3 mb-sm-0">
                  Appointment
                  <span className="right-icon"><i className="feather icon-arrow-right" /></span>
                </Link>
                <div className="info-widget style-5">
                  <div className="widget-media text-primary">
                    <i className="feather icon-phone-call dz-ring-effect" />
                  </div>
                  <div className="widget-content">
                    <h6 className="title">हमसे संपर्क करें</h6>
                    <a href="tel:+91 9165155945" className="text-secondary">+91 9165155945</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="content-inner-3 bg-secondary background-blend-multiply bg-img-fix" style={{ backgroundImage: 'url(./assets/images/background/bg2.webp)', backgroundRepeat: 'no-repeat', backgroundPosition: 'right center', backgroundSize: 'cover' }}>
        <div className="container">
          <div className="row align-items-sm-center">

            <div className="col-lg-3 col-4 m-b30 d-flex wow fadeInUp" data-wow-delay="0.4s" data-wow-duration="0.8s" style={{ animationDuration: '0.8s', animationDelay: '0.4s', animationName: 'none' }}>
              <div className="content-bx style-1 mx-auto">
                <span className="content-text text-white"><span className="counter">10</span>+</span>
                <h3 className="title text-white m-b0">साल का अनुभव</h3>
              </div>
            </div>
            <div className="col-lg-3 col-4 m-b30 d-flex wow fadeInUp" data-wow-delay="0.6s" data-wow-duration="0.8s" style={{ animationDuration: '0.8s', animationDelay: '0.6s', animationName: 'none' }}>
              <div className="content-bx style-1 mx-auto">
                <span className="content-text text-white"><span className="counter"></span>30+</span>
                <h3 className="title text-white m-b0">100% एक्सपर्ट डॉक्टर</h3>
              </div>
            </div>
            <div className="col-lg-3 col-4 m-b30 d-flex wow fadeInUp" data-wow-delay="0.8s" data-wow-duration="0.8s" style={{ animationDuration: '0.8s', animationDelay: '0.8s', animationName: 'none' }}>
              <div className="content-bx style-1 mx-auto">
                <span className="content-text text-white"><span className="counter">15</span>+</span>
                <h3 className="title text-white m-b0">अवॉर्ड्स जीते</h3>
              </div>
            </div>
            <div className="col-lg-3 col-4 m-b30 d-flex wow fadeInUp" data-wow-delay="0.8s" data-wow-duration="0.8s" style={{ animationDuration: '0.8s', animationDelay: '0.8s', animationName: 'none' }}>
              <div className="content-bx style-1 mx-auto">
                <span className="content-text text-white"><span className="counter">1500</span>+</span>
                <h3 className="title text-white m-b0">खुश मरीज़</h3>
              </div>
            </div>
          </div>
        </div>
      </section>

    </>
  )
}

export default PressRelease